export default {
  listInvoice: [],
  invoice: null,
}
